import { c as _c } from "react/compiler-runtime";
import Lazy from "@components/Lazy";
import Section from "@components/Section";
import { useBreakpoints } from "@justhome/common/hooks";
import { ComponentSectionsHeyflow } from "@lib/generated/graphql";
import useApplicationContext from "@modules/application/hooks/useApplicationContext";
import { useRouter } from "@lib/hooks/useRouter";
import Script from "next/script";
import { FC, useCallback, useEffect, useRef, useState } from "react";
export interface HeyflowProps {
  data: ComponentSectionsHeyflow;
  index: number;
}
const Heyflow: FC<HeyflowProps> = t0 => {
  const $ = _c(16);
  const {
    data,
    index
  } = t0;
  const {
    xs,
    s
  } = useBreakpoints();
  const heyflowWrapperRef = useRef(null);
  const [isActive, setIsActive] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsActive(true);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleLoad = t1;
  const {
    state
  } = useApplicationContext();
  const router = useRouter();
  const leadId = state.lead?.id;
  let urlParams;
  if ($[1] !== leadId || $[2] !== router.query) {
    urlParams = new URLSearchParams(router.query as Record<string, string>);
    if (leadId) {
      urlParams.set("utm_term", leadId);
    }
    $[1] = leadId;
    $[2] = router.query;
    $[3] = urlParams;
  } else {
    urlParams = $[3];
  }
  let t2;
  let t3;
  if ($[4] !== isActive) {
    t2 = () => {
      if (!isActive) {
        return;
      }
      let timeoutId;
      const updateFont = () => {
        if (!heyflowWrapperRef.current) {
          return;
        }
        const shadowRoot = heyflowWrapperRef.current.shadowRoot;
        if (shadowRoot) {
          const styles = document.createElement("style");
          styles.innerText = "\n            * {\n              font-family: SuisseIntl, sans-serif !important; \n              font-weight: 400 !important;\n            }\n            h3, h4, h5, h6 {\n              font-family: 'PSFournier Pro', serif !important; font-style: italic !important; \n            }\n          ";
          shadowRoot.appendChild(styles);
        } else {
          timeoutId = window.setTimeout(updateFont, 300);
        }
      };
      updateFont();
      return () => {
        clearTimeout(timeoutId);
      };
    };
    t3 = [isActive];
    $[4] = isActive;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Script src="https://static.heyflow.app/widget/latest/webview.js" />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = xs || s || undefined;
  let t6;
  if ($[8] !== data.heyflowId || $[9] !== t5 || $[10] !== urlParams) {
    t6 = <Lazy onLoad={handleLoad}>{t4}<heyflow-wrapper url-parameters={urlParams} ref={heyflowWrapperRef} flow-id={data.heyflowId} dynamic-height={true} scroll-up-on-navigation={t5} style-config={"{\"width\": \"100%\"}"} /></Lazy>;
    $[8] = data.heyflowId;
    $[9] = t5;
    $[10] = urlParams;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== data || $[13] !== index || $[14] !== t6) {
    t7 = <Section section={data} index={index} id={data.heyflowId} className="my-2s m:my-3s px-m py-3m bg-neutral-12">{t6}</Section>;
    $[12] = data;
    $[13] = index;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
export default Heyflow;